import React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AppleIcon from "@material-ui/icons/Apple";
import AndroidIcon from "@material-ui/icons/Android";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(8, 2),
    backgroundColor: "#fff",
  },
  heading: {
    fontWeight: 700,
    fontSize: "2rem",
    marginBottom: theme.spacing(1),
  },
  highlight: {
    color: "#007bff",
  },
  subheading: {
    color: "#666",
    marginBottom: theme.spacing(3),
  },
  listItemIcon: {
    color: "#4caf50",
    minWidth: 36,
  },
  buttonGroup: {
    marginTop: theme.spacing(3),
  },
  stats: {
    marginTop: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(3),
    alignItems: "center",
  },
  statBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: "#555",
  },
  phoneMock: {
    width: 220,
    height: 440,
    border: "4px solid #000",
    borderRadius: 30,
    margin: "auto",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#007bff",
    fontSize: 18,
    fontWeight: 500,
  },
  tagLiveSync: {
    position: "absolute",
    top: 10,

    backgroundColor: "#4caf50",
    color: "#fff",
    padding: "4px 10px",
    fontSize: 12,
    borderRadius: 8,
  },
  tagAccess: {
    position: "absolute",
    bottom: 10,

    backgroundColor: "#ff9800",
    color: "#fff",
    padding: "4px 10px",
    fontSize: 12,
    borderRadius: 8,
  },
}));

const AppSection = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography className={classes.heading}>
            Take MonteStory <span className={classes.highlight}>Anywhere</span>
          </Typography>
          <Typography className={classes.subheading}>
            Stay connected with your school community on-the-go. Our mobile
            applications for iOS and Android provide full access to all features
            with an optimized mobile experience.
          </Typography>

          <List dense>
            {[
              "Real-time notifications for important updates",
             
            ].map((text, index) => (
              <ListItem key={index}>
                <ListItemIcon className={classes.listItemIcon}>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>

          <Box className={classes.buttonGroup}>
            <Button
              variant="contained"
              color="default"
              startIcon={<AppleIcon />}
              style={{ marginRight: 12 }}
            >
              App Store
            </Button>
            <Button variant="contained" color="default" startIcon={<AndroidIcon />}>
              Google Play
            </Button>
          </Box>

        
        </Grid>

        <Grid item xs={12} md={6}>
          <Box >
            <div className={classes.tagLiveSync}>🟢 Live Sync</div>
           
           <img
                src="/images/div.png"
                alt="Kids Illustration"
                style={{ maxWidth: "100%", height: "500px", width: "300px", borderRadius: "10px" }}
              />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AppSection;
